export default __webpack_public_path__ + "static/media/Tamara_9781408316870.1a09ac0c.jpg";